(function () {
  const DEFAULT_LOCALE = 'en'

  const messages = {
    en: {
      'nav.home': 'Home',
      'nav.language': 'Language',
      'nav.contact': 'Contact Us',
      'nav.download': 'Download',

      'hero.title': 'KeyMart',
      'hero.subtitle': 'Made for Instant Shopping',
      'hero.desc': 'Everything you need, at your fingertips',
      'hero.more': 'MORE',

      'smartPicks.title': 'Smart Picks · Quick Find',
      'smartPicks.desc1': 'Personalized recommendations based on your daily habits.',
      'smartPicks.desc2': 'Efficient search and clear categories help you browse with ease.',
      'smartPicks.desc3': 'Find your everyday essentials quickly, right when you need them',

      'easyOrders.title': 'Easy Orders · Smooth Checkout',
      'easyOrders.desc1': 'Manage items and quantities effortlessly in your cart.',
      'easyOrders.desc2': 'A clear and smooth checkout flow saves you time.',
      'easyOrders.desc3': 'Multiple payment options supported,',
      'easyOrders.desc4': 'so every order is completed quickly and securely',

      'support.title': '24/7 Expert Support',
      'support.desc1': 'Get help with orders, delivery, or after-sales service anytime.',
      'support.desc2': 'Our professional team responds quickly,',
      'support.desc3': 'ensuring a reliable and worry-free shopping experience.',

      'delivery.title': 'Fast Delivery · Same-Day',
      'delivery.desc1': 'An efficient logistics system built for everyday needs.',
      'delivery.desc2': 'Orders are processed and shipped quickly.',
      'delivery.desc3': 'Same-day delivery available in selected areas, so your daily essentials arrive without delay.',

      'footer.download': 'Download',
      'footer.followUs': 'Follow us on',
      'footer.iosApp': 'KeyMart iOS',
      'footer.androidApp': 'KeyMart Android',
      'footer.apkTitle': 'Download APK',
      'footer.apkSubtitle': '(Official Website)',
      'footer.comingSoon': 'Coming soon',
      'footer.copyright': 'Copyright © 2026 KeyMart 丨 Powered by Asite',
      'footer.aboutUs': 'About us',
      'footer.aboutDesc': 'Asite is a technology company dedicated to building global digital commerce platforms. Our flagship product, KeyMart, provides instant shopping services across Southeast Asia, delivering everyday essentials to users quickly and conveniently.'
    },
    zh: {
      'nav.home': '首页',
      'nav.language': '语言',
      'nav.contact': '联系我们',
      'nav.download': '下载',

      'hero.title': 'KeyMart',
      'hero.subtitle': '为即时购物而生',
      'hero.desc': '一切所需，尽在指尖',
      'hero.more': '更多',

      'smartPicks.title': '智能推荐 · 快速查找',
      'smartPicks.desc1': '根据您的日常习惯进行个性化推荐。',
      'smartPicks.desc2': '高效搜索和清晰分类，轻松浏览。',
      'smartPicks.desc3': '在您需要时快速找到日常必需品',

      'easyOrders.title': '轻松下单 · 顺畅结账',
      'easyOrders.desc1': '在购物车中轻松管理商品和数量。',
      'easyOrders.desc2': '清晰顺畅的结账流程，节省您的时间。',
      'easyOrders.desc3': '支持多种支付方式，',
      'easyOrders.desc4': '让每一笔订单都快速安全完成',

      'support.title': '7x24小时专业支持',
      'support.desc1': '随时获取订单、配送或售后服务帮助。',
      'support.desc2': '我们的专业团队快速响应，',
      'support.desc3': '确保可靠无忧的购物体验。',

      'delivery.title': '快速配送 · 当日达',
      'delivery.desc1': '为日常需求打造的高效物流系统。',
      'delivery.desc2': '订单快速处理和发货。',
      'delivery.desc3': '部分地区支持当日达，让您的日常必需品及时送达。',

      'footer.download': '下载',
      'footer.followUs': '关注我们',
      'footer.iosApp': 'KeyMart iOS',
      'footer.androidApp': 'KeyMart 安卓版',
      'footer.apkTitle': '下载 APK',
      'footer.apkSubtitle': '(官方网站)',
      'footer.comingSoon': '即将上线',
      'footer.copyright': 'Copyright © 2026 KeyMart 丨 Powered by Asite',
      'footer.aboutUs': '关于我们',
      'footer.aboutDesc': 'Asite 是一家致力于构建全球数字商业平台的技术公司。我们的旗舰产品 KeyMart 在东南亚提供即时购物服务，快速便捷地为用户送达日常所需。'
    },
    ja: {
      'nav.home': 'ホーム',
      'nav.language': '言語',
      'nav.contact': 'お問い合わせ',
      'nav.download': 'ダウンロード',

      'hero.title': 'KeyMart',
      'hero.subtitle': 'すぐに買える、日常のショッピングのために',
      'hero.desc': '必要なものを、指先ひとつで',
      'hero.more': 'もっと見る',

      'smartPicks.title': 'スマートピック・クイック検索',
      'smartPicks.desc1': '日常の習慣に基づいたパーソナライズされたおすすめ。',
      'smartPicks.desc2': '効率的な検索と明確なカテゴリで簡単に閲覧。',
      'smartPicks.desc3': '必要なときに日用品をすぐに見つけられます',

      'easyOrders.title': '簡単注文・スムーズな決済',
      'easyOrders.desc1': 'カートで商品と数量を簡単に管理。',
      'easyOrders.desc2': '明確でスムーズな決済フローで時間を節約。',
      'easyOrders.desc3': '複数の支払い方法に対応し、',
      'easyOrders.desc4': 'すべての注文を迅速かつ安全に完了',

      'support.title': '24時間年中無休のサポート',
      'support.desc1': '注文、配送、アフターサービスについていつでもサポートを受けられます。',
      'support.desc2': '専門チームが迅速に対応し、',
      'support.desc3': '安心で信頼できるショッピング体験を提供します。',

      'delivery.title': '高速配送・当日配達',
      'delivery.desc1': '日常のニーズに対応した効率的な物流システム。',
      'delivery.desc2': '注文は迅速に処理・発送されます。',
      'delivery.desc3': '一部地域では当日配達も可能、日用品が遅延なく届きます。',

      'footer.download': 'ダウンロード',
      'footer.followUs': 'フォロー',
      'footer.iosApp': 'KeyMart iOS',
      'footer.androidApp': 'KeyMart Android',
      'footer.apkTitle': 'APKをダウンロード',
      'footer.apkSubtitle': '(公式サイト)',
      'footer.comingSoon': '近日公開',
      'footer.copyright': 'Copyright © 2026 KeyMart 丨 Powered by Asite',
      'footer.aboutUs': '会社概要',
      'footer.aboutDesc': 'Asiteはグローバルなデジタルコマースプラットフォームの構築に取り組むテクノロジー企業です。主力製品KeyMartは東南アジアで即時ショッピングサービスを提供し、日用品を迅速かつ便利にお届けします。'
    },
    ko: {
      'nav.home': '홈',
      'nav.language': '언어',
      'nav.contact': '문의하기',
      'nav.download': '다운로드',

      'hero.title': 'KeyMart',
      'hero.subtitle': '즉시 쇼핑을 위해 만들어졌습니다',
      'hero.desc': '필요한 모든 것을, 손끝에서',
      'hero.more': '더보기',

      'smartPicks.title': '스마트 픽 · 빠른 검색',
      'smartPicks.desc1': '일상 습관에 기반한 맞춤 추천.',
      'smartPicks.desc2': '효율적인 검색과 명확한 카테고리로 쉽게 탐색.',
      'smartPicks.desc3': '필요할 때 일상 필수품을 빠르게 찾으세요',

      'easyOrders.title': '쉬운 주문 · 원활한 결제',
      'easyOrders.desc1': '장바구니에서 상품과 수량을 쉽게 관리.',
      'easyOrders.desc2': '명확하고 원활한 결제 흐름으로 시간 절약.',
      'easyOrders.desc3': '다양한 결제 옵션 지원,',
      'easyOrders.desc4': '모든 주문이 빠르고 안전하게 완료됩니다',

      'support.title': '24시간 전문 지원',
      'support.desc1': '언제든지 주문, 배송 또는 애프터 서비스 도움을 받으세요.',
      'support.desc2': '전문 팀이 신속하게 응답하여,',
      'support.desc3': '신뢰할 수 있고 걱정 없는 쇼핑 경험을 보장합니다.',

      'delivery.title': '빠른 배송 · 당일 배송',
      'delivery.desc1': '일상 필요에 맞춘 효율적인 물류 시스템.',
      'delivery.desc2': '주문이 신속하게 처리되고 배송됩니다.',
      'delivery.desc3': '일부 지역에서 당일 배송 가능, 일상 필수품이 지체 없이 도착합니다.',

      'footer.download': '다운로드',
      'footer.followUs': '팔로우',
      'footer.iosApp': 'KeyMart iOS',
      'footer.androidApp': 'KeyMart 안드로이드',
      'footer.apkTitle': 'APK 다운로드',
      'footer.apkSubtitle': '(공식 웹사이트)',
      'footer.comingSoon': '곧 출시',
      'footer.copyright': 'Copyright © 2026 KeyMart 丨 Powered by Asite',
      'footer.aboutUs': '회사 소개',
      'footer.aboutDesc': 'Asite는 글로벌 디지털 커머스 플랫폼 구축에 힘쓰는 기술 기업입니다. 대표 제품 KeyMart는 동남아 전역에서 즉시 쇼핑 서비스를 제공하며, 일상 필수품을 빠르고 편리하게 전달합니다.'
    }
  }

  function getInitialLocale() {
    try {
      const saved = localStorage.getItem('locale')
      if (saved && messages[saved]) return saved
    } catch (e) {}
    return DEFAULT_LOCALE
  }

  const state = {
    locale: getInitialLocale(),
    isMenuOpen: false,
    isLanguageOpen: false,
    showAndroidTooltip: false
  }

  function t(key) {
    const dict = messages[state.locale] || messages[DEFAULT_LOCALE]
    return dict[key] || key
  }

  function getLocaleName(locale) {
    const names = {
      en: 'English',
      zh: '中文',
      ja: '日本語',
      ko: '한국어'
    }
    return names[locale] || locale
  }

  function setLocale(locale) {
    if (!messages[locale]) return
    state.locale = locale
    try {
      localStorage.setItem('locale', locale)
    } catch (e) {}
    applyI18n()
    updateLocaleActiveUI()
    closeLanguageModal()
  }

  function applyI18n() {
    document.documentElement.lang = state.locale === 'zh' ? 'zh-CN' : state.locale

    const nodes = document.querySelectorAll('[data-i18n]')
    nodes.forEach((el) => {
      const key = el.getAttribute('data-i18n')
      if (!key) return
      el.textContent = t(key)
    })

    const heroSubtitle = document.querySelector('.hero-subtitle')
    if (heroSubtitle) {
      heroSubtitle.classList.toggle('hero-subtitle-ko', state.locale === 'ko')
    }
  }

  function updateLocaleActiveUI() {
    const localeItems = document.querySelectorAll('[data-locale]')
    localeItems.forEach((el) => {
      const lang = el.getAttribute('data-locale')
      el.classList.toggle('active', lang === state.locale)

      const check = el.querySelector('.language-check')
      if (check) {
        check.style.display = lang === state.locale ? 'flex' : 'none'
      }
    })
  }

  function openMenu() {
    state.isMenuOpen = true
    document.documentElement.classList.add('menu-open')
    syncMenuUI()
  }

  function closeMenu() {
    state.isMenuOpen = false
    state.isLanguageOpen = false
    document.documentElement.classList.remove('menu-open')
    syncMenuUI()
    closeLanguageModal()
  }

  function toggleMenu() {
    if (state.isMenuOpen) closeMenu()
    else openMenu()
  }

  function syncMenuUI() {
    const overlay = document.querySelector('.nav-overlay')
    const nav = document.querySelector('.nav')
    const toggleBtn = document.querySelector('.menu-toggle')

    if (overlay) overlay.classList.toggle('show', state.isMenuOpen)
    if (nav) nav.classList.toggle('nav-open', state.isMenuOpen)
    if (toggleBtn) toggleBtn.classList.toggle('menu-open', state.isMenuOpen)
  }

  function openLanguageModal() {
    state.isLanguageOpen = true
    const overlay = document.querySelector('.language-modal-overlay')
    const modal = document.querySelector('.language-modal')
    if (overlay) overlay.classList.add('show')
    if (modal) modal.classList.add('show')
  }

  function closeLanguageModal() {
    state.isLanguageOpen = false
    const overlay = document.querySelector('.language-modal-overlay')
    const modal = document.querySelector('.language-modal')
    if (overlay) overlay.classList.remove('show')
    if (modal) modal.classList.remove('show')
  }

  function toggleLanguageDropdownMobile() {
    if (window.innerWidth <= 768) {
      state.isMenuOpen = false
      syncMenuUI()
      if (state.isLanguageOpen) closeLanguageModal()
      else openLanguageModal()
    }
  }

  function scrollToId(id) {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  function bindEvents() {
    const menuToggle = document.querySelector('.menu-toggle')
    if (menuToggle) {
      menuToggle.addEventListener('click', (e) => {
        e.preventDefault()
        toggleMenu()
      })
    }

    const navOverlay = document.querySelector('.nav-overlay')
    if (navOverlay) {
      navOverlay.addEventListener('click', (e) => {
        e.preventDefault()
        closeMenu()
      })
    }

    document.querySelectorAll('[data-close-menu]')
      .forEach((a) => a.addEventListener('click', () => closeMenu()))

    const langTrigger = document.querySelector('[data-action="open-language"]')
    if (langTrigger) {
      langTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        toggleLanguageDropdownMobile()
      })
    }

    const langOverlay = document.querySelector('.language-modal-overlay')
    if (langOverlay) {
      langOverlay.addEventListener('click', (e) => {
        e.preventDefault()
        closeLanguageModal()
      })
    }

    const langClose = document.querySelector('.language-modal-close')
    if (langClose) {
      langClose.addEventListener('click', (e) => {
        e.preventDefault()
        closeLanguageModal()
      })
    }

    document.querySelectorAll('[data-locale]')
      .forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault()
          const lang = el.getAttribute('data-locale')
          if (lang) setLocale(lang)
        })
      })

    document.querySelectorAll('[data-action="scroll-smart-picks"]')
      .forEach((moreBtn) => {
        moreBtn.addEventListener('click', (e) => {
          e.preventDefault()
          scrollToId('smart-picks')
        })
      })

    document.querySelectorAll('[data-scroll-next]')
      .forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault()
          const next = btn.getAttribute('data-scroll-next')
          if (next) scrollToId(next)
        })
      })

    const androidBtn = document.querySelector('[data-action="android-tooltip"]')
    if (androidBtn) {
      androidBtn.addEventListener('click', (e) => {
        const href = androidBtn.getAttribute('href')
        // 如果有链接则跳转，否则显示 tooltip
        if (href && href !== '#' && href !== 'javascript:void(0)') {
          // 有链接，允许默认跳转行为
          return
        }
        e.preventDefault()
        showTooltip('.android-wrapper .tooltip')
      })
    }

  }

  // 通用 tooltip 显示函数
  const tooltipTimers = {}
  function showTooltip(selector) {
    const tooltip = document.querySelector(selector)
    if (!tooltip) return

    tooltip.style.display = 'block'
    clearTimeout(tooltipTimers[selector])
    tooltipTimers[selector] = setTimeout(() => {
      tooltip.style.display = 'none'
    }, 1000)
  }

  function mobileRedirectIfNeeded() {
    // Keep the original inline redirect behavior in index.html.
    // This hook is left intentionally for parity / future config.
  }

  function init() {
    mobileRedirectIfNeeded()
    bindEvents()
    applyI18n()
    updateLocaleActiveUI()

    const tooltip = document.querySelector('.tooltip')
    if (tooltip) tooltip.style.display = 'none'
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})();

